import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Slider from "components/Slider";
import Loader from "components/Loader";
import Category from "components/Home/TodayOffers/Categories/Category";
import style from './style.scss'; //NOSONAR
import TagManagerService from 'services/TagManager';

const SliderCategories = (props) => {
    if (!props.categories) return '';
    let shelfIsland  = props.shelfIsland ? props.shelfIsland : 0;
    useEffect(() => {
        promotionView();
    }, []) 

    const promotionView = () => {
        let categoriesArr = props.categories.map((category, i) => {
            return {
                id: category.category,
                name: category.title,
                position:  'slot'+(i+1),
                creative: 'Vitrina '+shelfIsland
            }
        })

        TagManagerService.promotionsImpressions(categoriesArr);
    }

    return (
        <div className="categories-slide-container">
            {props.isLoading &&
                <div className="categorys-slider-loader">
                    <Loader />
                </div>}
            {!props.isLoading && <Slider arrows={true} className={"category-slider-wrap " + (props.active !== true ? "category-slider-fullwidth" : '')}>
                {(props.categories) && props.categories.map((category, i) =>
                    <Category category={category} key={i} position={i + 1}/>
                )}
            </Slider>}
        </div>
    );
};

SliderCategories.propTypes = {
    id: PropTypes.number,
    isLoading: PropTypes.bool,
    categories: PropTypes.array,
    date: PropTypes.number,
    active: PropTypes.bool,
    shelfIsland: PropTypes.number
};

export default SliderCategories;
